// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ── Cuenta / Estudio top-tabs panel ── */
.cfg-tab-panel {
  padding: 24px 0 32px;
}

/* Field grid / field display are defined in ui/FieldDisplay/FieldDisplay.css
   (the CfgFieldDisplay component). Only the responsive collapse lives here so
   the grid drops to one column before labels/values get clipped. */
@media (max-width: 560px) {
  .cfg-field-grid,
  .cfg-field-grid.cols-3 {
    grid-template-columns: 1fr;
    gap: 14px;
    padding: 18px 16px;
  }
}

/* ── Card tile (Tarjetas) ── */
.cfg-card-tile {
  border: 1px solid var(--border);
  background: var(--bg-alt);
  border-radius: var(--r-data);
  padding: 18px 20px;
  display: grid;
  grid-template-columns: 1fr auto;
  gap: 12px;
  align-items: center;
  margin-bottom: 12px;
}

.cfg-card-tile__info .cfg-card-brand {
  font-family: var(--display);
  font-weight: 400;
  font-size: var(--fs-md);
  color: var(--text);
}

.cfg-card-tile__info .cfg-card-pan {
  font-family: var(--mono);
  font-size: var(--fs-meta);
  color: var(--text-muted);
  margin-top: 2px;
}

.cfg-card-tile__info .cfg-card-meta {
  font-size: var(--fs-xs);
  color: var(--text-muted);
  margin-top: 4px;
}

.cfg-principal-pill {
  display: inline-block;
  font-family: var(--mono);
  font-size: var(--fs-nano);
  letter-spacing: 0.1em;
  text-transform: uppercase;
  background: transparent;
  border: 1px solid var(--ok);
  color: var(--ok);
  padding: 1px 6px;
  border-radius: var(--radius-0);
  margin-left: 8px;
}

.cfg-card-tile__actions {
  display: flex;
  gap: 8px;
  align-items: center;
}

/* Row-action buttons use the shared .row-action atom (styles/atoms.css). */

.cfg-add-card-wrap {
  margin-top: 4px;
}

/* ── Settings screens: section shell, form grid, preference rows, and the
   segmented / swatch / switch controls. Used by the Cuenta and Estudio
   screens (ConfiguracionForm). ── */
.settings {
  display: flex;
  flex-direction: column;
  gap: var(--s-10);
}
.set-section__head {
  display: flex;
  align-items: flex-end;
  justify-content: space-between;
  gap: 16px;
  padding-bottom: 14px;
  border-bottom: 1px solid var(--rule);
  margin-bottom: 18px;
}
.set-section__title {
  font-family: var(--display);
  font-weight: 400;
  font-size: var(--fs-title-sm);
  letter-spacing: -0.02em;
  color: var(--ink);
  margin: 4px 0 0;
}
.set-section__right {
  display: flex;
  align-items: center;
  gap: 14px;
}
.form-grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 16px 18px;
}
.form-grid .fld--full {
  grid-column: 1 / -1;
}
.form-field {
  display: flex;
  flex-direction: column;
  gap: 6px;
}
.form-field__label {
  font-family: var(--mono);
  font-size: var(--fs-eyebrow);
  letter-spacing: 0.14em;
  text-transform: uppercase;
  color: var(--ink-3);
}
.profile-head {
  display: flex;
  align-items: center;
  gap: 14px;
  margin-bottom: 22px;
}
.profile-head__av {
  width: 56px;
  height: 56px;
  border-radius: 999px;
  display: grid;
  place-items: center;
  background: var(--accent);
  color: var(--accent-ink);
  font-family: var(--mono);
  font-size: var(--fs-prose);
  font-weight: 600;
  letter-spacing: 0.04em;
  flex: none;
}
.prefrow,
.pref {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  padding: 14px 0;
  border-bottom: 1px solid var(--rule-soft);
}
.pref {
  cursor: pointer;
}
.prefrow:last-child,
.pref:last-child {
  border-bottom: 0;
}
.prefrow__lbl {
  display: flex;
  flex-direction: column;
  gap: 3px;
  font-size: var(--fs-detail);
  color: var(--ink);
}
.prefrow__lbl .note {
  font-size: var(--fs-meta);
}
.swatchset {
  display: flex;
  gap: 8px;
  flex-wrap: wrap;
}
.swatch {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  height: 32px;
  padding: 0 12px 0 10px;
  border: 1px solid var(--rule);
  background: var(--surface);
  border-radius: var(--r-1);
  font-family: var(--sans);
  font-size: var(--fs-2xs);
  color: var(--ink-2);
  cursor: pointer;
}
.swatch:hover {
  border-color: var(--ink-3);
}
.swatch.is-on {
  border-color: var(--accent);
  color: var(--ink);
}
.swatch__dot {
  width: 13px;
  height: 13px;
  border-radius: 999px;
  flex: none;
  box-shadow: inset 0 0 0 1px rgba(0, 0, 0, 0.08);
}
.switch {
  width: 38px;
  height: 22px;
  border-radius: 999px;
  border: 1px solid var(--rule);
  background: var(--paper-elev);
  position: relative;
  flex: none;
  cursor: pointer;
  transition:
    background var(--dur-2) var(--ease),
    border-color var(--dur-2);
}
.switch__dot {
  position: absolute;
  top: 2px;
  left: 2px;
  width: 16px;
  height: 16px;
  border-radius: 999px;
  background: var(--ink-3);
  transition:
    transform var(--dur-2) var(--ease),
    background var(--dur-2);
}
.switch--on {
  background: var(--accent);
  border-color: var(--accent);
}
.switch--on .switch__dot {
  transform: translateX(16px);
  background: var(--accent-ink);
}
.switch:disabled,
.pref--soon .switch {
  opacity: 0.5;
}
@media (max-width: 560px) {
  .prefrow {
    flex-direction: column;
    align-items: flex-start;
    gap: 10px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/pages/configuracion/Configuracion.css"],"names":[],"mappings":"AAAA,0CAA0C;AAC1C;EACE,oBAAoB;AACtB;;AAEA;;mEAEmE;AACnE;EACE;;IAEE,0BAA0B;IAC1B,SAAS;IACT,kBAAkB;EACpB;AACF;;AAEA,+BAA+B;AAC/B;EACE,+BAA+B;EAC/B,yBAAyB;EACzB,4BAA4B;EAC5B,kBAAkB;EAClB,aAAa;EACb,+BAA+B;EAC/B,SAAS;EACT,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,2BAA2B;EAC3B,gBAAgB;EAChB,uBAAuB;EACvB,kBAAkB;AACpB;;AAEA;EACE,wBAAwB;EACxB,yBAAyB;EACzB,wBAAwB;EACxB,eAAe;AACjB;;AAEA;EACE,uBAAuB;EACvB,wBAAwB;EACxB,eAAe;AACjB;;AAEA;EACE,qBAAqB;EACrB,wBAAwB;EACxB,yBAAyB;EACzB,qBAAqB;EACrB,yBAAyB;EACzB,uBAAuB;EACvB,2BAA2B;EAC3B,gBAAgB;EAChB,gBAAgB;EAChB,8BAA8B;EAC9B,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,mBAAmB;AACrB;;AAEA,2EAA2E;;AAE3E;EACE,eAAe;AACjB;;AAEA;;oCAEoC;AACpC;EACE,aAAa;EACb,sBAAsB;EACtB,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,qBAAqB;EACrB,8BAA8B;EAC9B,SAAS;EACT,oBAAoB;EACpB,oCAAoC;EACpC,mBAAmB;AACrB;AACA;EACE,2BAA2B;EAC3B,gBAAgB;EAChB,6BAA6B;EAC7B,uBAAuB;EACvB,iBAAiB;EACjB,eAAe;AACjB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;AACA;EACE,aAAa;EACb,8BAA8B;EAC9B,cAAc;AAChB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;AACA;EACE,wBAAwB;EACxB,4BAA4B;EAC5B,sBAAsB;EACtB,yBAAyB;EACzB,mBAAmB;AACrB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,mBAAmB;AACrB;AACA;EACE,WAAW;EACX,YAAY;EACZ,oBAAoB;EACpB,aAAa;EACb,mBAAmB;EACnB,yBAAyB;EACzB,wBAAwB;EACxB,wBAAwB;EACxB,0BAA0B;EAC1B,gBAAgB;EAChB,sBAAsB;EACtB,UAAU;AACZ;AACA;;EAEE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,eAAe;EACf,yCAAyC;AAC3C;AACA;EACE,eAAe;AACjB;AACA;;EAEE,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,2BAA2B;EAC3B,iBAAiB;AACnB;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,aAAa;EACb,QAAQ;EACR,eAAe;AACjB;AACA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,YAAY;EACZ,sBAAsB;EACtB,6BAA6B;EAC7B,0BAA0B;EAC1B,yBAAyB;EACzB,wBAAwB;EACxB,wBAAwB;EACxB,mBAAmB;EACnB,eAAe;AACjB;AACA;EACE,0BAA0B;AAC5B;AACA;EACE,2BAA2B;EAC3B,iBAAiB;AACnB;AACA;EACE,WAAW;EACX,YAAY;EACZ,oBAAoB;EACpB,UAAU;EACV,+CAA+C;AACjD;AACA;EACE,WAAW;EACX,YAAY;EACZ,oBAAoB;EACpB,6BAA6B;EAC7B,6BAA6B;EAC7B,kBAAkB;EAClB,UAAU;EACV,eAAe;EACf;;6BAE2B;AAC7B;AACA;EACE,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,WAAW;EACX,YAAY;EACZ,oBAAoB;EACpB,wBAAwB;EACxB;;2BAEyB;AAC3B;AACA;EACE,yBAAyB;EACzB,2BAA2B;AAC7B;AACA;EACE,2BAA2B;EAC3B,6BAA6B;AAC/B;AACA;;EAEE,YAAY;AACd;AACA;EACE;IACE,sBAAsB;IACtB,uBAAuB;IACvB,SAAS;EACX;AACF","sourcesContent":["/* ── Cuenta / Estudio top-tabs panel ── */\n.cfg-tab-panel {\n  padding: 24px 0 32px;\n}\n\n/* Field grid / field display are defined in ui/FieldDisplay/FieldDisplay.css\n   (the CfgFieldDisplay component). Only the responsive collapse lives here so\n   the grid drops to one column before labels/values get clipped. */\n@media (max-width: 560px) {\n  .cfg-field-grid,\n  .cfg-field-grid.cols-3 {\n    grid-template-columns: 1fr;\n    gap: 14px;\n    padding: 18px 16px;\n  }\n}\n\n/* ── Card tile (Tarjetas) ── */\n.cfg-card-tile {\n  border: 1px solid var(--border);\n  background: var(--bg-alt);\n  border-radius: var(--r-data);\n  padding: 18px 20px;\n  display: grid;\n  grid-template-columns: 1fr auto;\n  gap: 12px;\n  align-items: center;\n  margin-bottom: 12px;\n}\n\n.cfg-card-tile__info .cfg-card-brand {\n  font-family: var(--display);\n  font-weight: 400;\n  font-size: var(--fs-md);\n  color: var(--text);\n}\n\n.cfg-card-tile__info .cfg-card-pan {\n  font-family: var(--mono);\n  font-size: var(--fs-meta);\n  color: var(--text-muted);\n  margin-top: 2px;\n}\n\n.cfg-card-tile__info .cfg-card-meta {\n  font-size: var(--fs-xs);\n  color: var(--text-muted);\n  margin-top: 4px;\n}\n\n.cfg-principal-pill {\n  display: inline-block;\n  font-family: var(--mono);\n  font-size: var(--fs-nano);\n  letter-spacing: 0.1em;\n  text-transform: uppercase;\n  background: transparent;\n  border: 1px solid var(--ok);\n  color: var(--ok);\n  padding: 1px 6px;\n  border-radius: var(--radius-0);\n  margin-left: 8px;\n}\n\n.cfg-card-tile__actions {\n  display: flex;\n  gap: 8px;\n  align-items: center;\n}\n\n/* Row-action buttons use the shared .row-action atom (styles/atoms.css). */\n\n.cfg-add-card-wrap {\n  margin-top: 4px;\n}\n\n/* ── Settings screens: section shell, form grid, preference rows, and the\n   segmented / swatch / switch controls. Used by the Cuenta and Estudio\n   screens (ConfiguracionForm). ── */\n.settings {\n  display: flex;\n  flex-direction: column;\n  gap: var(--s-10);\n}\n.set-section__head {\n  display: flex;\n  align-items: flex-end;\n  justify-content: space-between;\n  gap: 16px;\n  padding-bottom: 14px;\n  border-bottom: 1px solid var(--rule);\n  margin-bottom: 18px;\n}\n.set-section__title {\n  font-family: var(--display);\n  font-weight: 400;\n  font-size: var(--fs-title-sm);\n  letter-spacing: -0.02em;\n  color: var(--ink);\n  margin: 4px 0 0;\n}\n.set-section__right {\n  display: flex;\n  align-items: center;\n  gap: 14px;\n}\n.form-grid {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 16px 18px;\n}\n.form-grid .fld--full {\n  grid-column: 1 / -1;\n}\n.form-field {\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n}\n.form-field__label {\n  font-family: var(--mono);\n  font-size: var(--fs-eyebrow);\n  letter-spacing: 0.14em;\n  text-transform: uppercase;\n  color: var(--ink-3);\n}\n.profile-head {\n  display: flex;\n  align-items: center;\n  gap: 14px;\n  margin-bottom: 22px;\n}\n.profile-head__av {\n  width: 56px;\n  height: 56px;\n  border-radius: 999px;\n  display: grid;\n  place-items: center;\n  background: var(--accent);\n  color: var(--accent-ink);\n  font-family: var(--mono);\n  font-size: var(--fs-prose);\n  font-weight: 600;\n  letter-spacing: 0.04em;\n  flex: none;\n}\n.prefrow,\n.pref {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 16px;\n  padding: 14px 0;\n  border-bottom: 1px solid var(--rule-soft);\n}\n.pref {\n  cursor: pointer;\n}\n.prefrow:last-child,\n.pref:last-child {\n  border-bottom: 0;\n}\n.prefrow__lbl {\n  display: flex;\n  flex-direction: column;\n  gap: 3px;\n  font-size: var(--fs-detail);\n  color: var(--ink);\n}\n.prefrow__lbl .note {\n  font-size: var(--fs-meta);\n}\n.swatchset {\n  display: flex;\n  gap: 8px;\n  flex-wrap: wrap;\n}\n.swatch {\n  display: inline-flex;\n  align-items: center;\n  gap: 8px;\n  height: 32px;\n  padding: 0 12px 0 10px;\n  border: 1px solid var(--rule);\n  background: var(--surface);\n  border-radius: var(--r-1);\n  font-family: var(--sans);\n  font-size: var(--fs-2xs);\n  color: var(--ink-2);\n  cursor: pointer;\n}\n.swatch:hover {\n  border-color: var(--ink-3);\n}\n.swatch.is-on {\n  border-color: var(--accent);\n  color: var(--ink);\n}\n.swatch__dot {\n  width: 13px;\n  height: 13px;\n  border-radius: 999px;\n  flex: none;\n  box-shadow: inset 0 0 0 1px rgba(0, 0, 0, 0.08);\n}\n.switch {\n  width: 38px;\n  height: 22px;\n  border-radius: 999px;\n  border: 1px solid var(--rule);\n  background: var(--paper-elev);\n  position: relative;\n  flex: none;\n  cursor: pointer;\n  transition:\n    background var(--dur-2) var(--ease),\n    border-color var(--dur-2);\n}\n.switch__dot {\n  position: absolute;\n  top: 2px;\n  left: 2px;\n  width: 16px;\n  height: 16px;\n  border-radius: 999px;\n  background: var(--ink-3);\n  transition:\n    transform var(--dur-2) var(--ease),\n    background var(--dur-2);\n}\n.switch--on {\n  background: var(--accent);\n  border-color: var(--accent);\n}\n.switch--on .switch__dot {\n  transform: translateX(16px);\n  background: var(--accent-ink);\n}\n.switch:disabled,\n.pref--soon .switch {\n  opacity: 0.5;\n}\n@media (max-width: 560px) {\n  .prefrow {\n    flex-direction: column;\n    align-items: flex-start;\n    gap: 10px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
